export default Object.freeze({
    DAILY: 'DAILY',
    SUM: 'SUM',
    AVG: 'AVG',
    MAX: 'MAX',
});
